import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Flex from '@blocks/Flex'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import { formatDate, route } from '@helpers'
import React from 'react'

export default function SalonUnavailableVoting() {
    const { salon } = useSalonContext()

    return (
        <EmphasizedContent>
            <h3>You're not participating in the salon.</h3>
            <p>Public results will be available on {formatDate(salon.state.results_date)}.</p>
            <Flex justifyContent="flex-start">
                <Button width="auto" to={route("customer:current")}>
                    See Open Salons
                </Button>
            </Flex>
        </EmphasizedContent>
    )
}